// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/icon_youshi01.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/icon_youshi02.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/icon_youshi03.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/icon_youshi04.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/icon_youshi05.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/icon_youshi06.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images/icon_youshi07.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images/icon_youshi08.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.advantage {
    background: #F4F5F7;
    padding-bottom: 0.52083rem;
    overflow: hidden;
}
.advantage-content {
    margin-top: 1.04167rem;
}
.adv-list {
    width: 7.29167rem;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.adv-item {
    background-color: #fff;
    width: 1.66667rem;
    text-align: center;
    box-sizing: border-box;
    padding: 0.26042rem 0.16667rem 0.16667rem 0.15625rem;
    margin-bottom: 0.20833rem;
    transition: all 0.5s ease;
    cursor: pointer;
    box-shadow: 0 0.02604rem 0.05208rem 0.04167rem rgba(171, 202, 215, .1);

}
.adv-item:hover {
    box-shadow: 0 0.10938rem 0.16146rem 0.05469rem #ABCAD74D;
}
.adv-item-icon {
    width: 0.375rem;
    height: 0.375rem;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-size: contain;
}
.adv11 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.adv2 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.adv3 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.adv4 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.adv5 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.adv6 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.adv7 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.adv8 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.adv-item-title {
    font-size: 0.125rem;
    color: #474D58;
    font-weight: 600;
    margin: 0.10417rem 0;
}
.adv-item-detail {
    color: #6F7783;
    font-size: 0.08333rem;
    text-align: left;
}

@media screen and (max-width: 700px) {
    .advantage-content {
        margin-top: 1.25rem;
    }
    .adv-list {
        width: 9.375rem;
    }
    .adv-item{
        width: 4.58333rem;
        padding: 0.26042rem 0.36458rem 0.36458rem 0.36458rem;
    }
    .adv-item-title {
        font-size: 0.27083rem;
        margin: 0.20833rem 0;
    }
    .adv-item-detail {
        font-size: 0.21875rem;
    }
    .adv-item-icon {
        width: 0.83333rem;
        height: 0.83333rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Adv/Adv.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,0BAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,sBAAiB;AACrB;AACA;IACI,iBAAa;IACb,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,iBAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,oDAA4B;IAC5B,yBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,sEAAoD;;AAExD;AACA;IACI,wDAA0C;AAC9C;AACA;IACI,eAAW;IACX,gBAAY;IACZ,cAAc;IACd,4BAA4B;IAC5B,wBAAwB;AAC5B;AACA;IACI,yDAA8D;AAClE;AACA;IACI,yDAA8D;AAClE;AACA;IACI,yDAA8D;AAClE;AACA;IACI,yDAA8D;AAClE;AACA;IACI,yDAA8D;AAClE;AACA;IACI,yDAA8D;AAClE;AACA;IACI,yDAA8D;AAClE;AACA;IACI,yDAA8D;AAClE;AACA;IACI,mBAAe;IACf,cAAc;IACd,gBAAgB;IAChB,oBAAgB;AACpB;AACA;IACI,cAAc;IACd,qBAAe;IACf,gBAAgB;AACpB;;AAEA;IACI;QACI,mBAAiB;IACrB;IACA;QACI,eAAa;IACjB;IACA;QACI,iBAAY;QACZ,oDAA4B;IAChC;IACA;QACI,qBAAe;QACf,oBAAgB;IACpB;IACA;QACI,qBAAe;IACnB;IACA;QACI,iBAAY;QACZ,kBAAa;IACjB;AACJ","sourcesContent":[".advantage {\n    background: #F4F5F7;\n    padding-bottom: 100px;\n    overflow: hidden;\n}\n.advantage-content {\n    margin-top: 200px;\n}\n.adv-list {\n    width: 1400px;\n    margin: 0 auto;\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n}\n\n.adv-item {\n    background-color: #fff;\n    width: 320px;\n    text-align: center;\n    box-sizing: border-box;\n    padding: 50px 32px 32px 30px;\n    margin-bottom: 40px;\n    transition: all 0.5s ease;\n    cursor: pointer;\n    box-shadow: 0px 5px 10px 8px rgba(171, 202, 215, .1);\n\n}\n.adv-item:hover {\n    box-shadow: 0px 21px 31px 10.5px #ABCAD74D;\n}\n.adv-item-icon {\n    width: 72px;\n    height: 72px;\n    margin: 0 auto;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n.adv11 {\n    background-image: url('../../assets/images/icon_youshi01.svg');\n}\n.adv2 {\n    background-image: url('../../assets/images/icon_youshi02.svg');\n}\n.adv3 {\n    background-image: url('../../assets/images/icon_youshi03.svg');\n}\n.adv4 {\n    background-image: url('../../assets/images/icon_youshi04.svg');\n}\n.adv5 {\n    background-image: url('../../assets/images/icon_youshi05.svg');\n}\n.adv6 {\n    background-image: url('../../assets/images/icon_youshi06.svg');\n}\n.adv7 {\n    background-image: url('../../assets/images/icon_youshi07.svg');\n}\n.adv8 {\n    background-image: url('../../assets/images/icon_youshi08.svg');\n}\n.adv-item-title {\n    font-size: 24px;\n    color: #474D58;\n    font-weight: 600;\n    margin: 20px 0px;\n}\n.adv-item-detail {\n    color: #6F7783;\n    font-size: 16px;\n    text-align: left;\n}\n\n@media screen and (max-width: 700px) {\n    .advantage-content {\n        margin-top: 240px;\n    }\n    .adv-list {\n        width: 1800px;\n    }\n    .adv-item{\n        width: 880px;\n        padding: 50px 70px 70px 70px;\n    }\n    .adv-item-title {\n        font-size: 52px;\n        margin: 40px 0px;\n    }\n    .adv-item-detail {\n        font-size: 42px;\n    }\n    .adv-item-icon {\n        width: 160px;\n        height: 160px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
